import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { getBusinesscategoriesApi } from "Apis/businessApi";
import { getBusinessSubcategoriesApi } from "Apis/businessApi";

export const BusinessContext = createContext();

export const BusinessContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [categoriesList, setCategoriesList] = useState([]);
  const [subCategoriesList, setSubCategoriesList] = useState([]);

  const getCategoryApi = async (id) => {
    let response = await getBusinesscategoriesApi(id);
    if (response?.status === 200) {
      setCategoriesList(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.name,
        }))
      );
    }
  };

  const getSubCategoryApi = async (id) => {
    let response = await getBusinessSubcategoriesApi(id);
    if (response?.status === 200) {
      setSubCategoriesList(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.name,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <BusinessContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        categoriesList,
        setCategoriesList,
        subCategoriesList,
        setSubCategoriesList,
        getCategoryApi,
        getSubCategoryApi,
      }}
    >
      {children}
    </BusinessContext.Provider>
  );
};

export default BusinessContextProvider;
BusinessContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
